const upcomingEvents = [
    {
        date: { month: "Every", day: "Friday" },
        title: "Chai Night",
        time: "After Isha",
        location: "ICSP - Community Hall",
        description:
            "Join us for some delicious chai, snacks and activites every week! P.S The last chai night for this semester is on the 2nd of May.",
        venue: "ICSP - Community Hall",
    },
    {
        date: { month: "Every", day: "Friday" },
        title: "Dawah",
        time: "11:00 AM - 01:00 PM",
        location: "Free Speech Area, between the SUB and the Library",
        description:
            "Invite others to Islam to inspire a purpose in life & express the importance of worshipping God.",
        venue: "Free Speech Area, TTU",
    }
    // {
    //     date: { month: "Nov", day: "23" },
    //     title: "Food Wars Cookoff",
    //     timeRange: "05:00 PM",
    //     location: "ICSP - Community Hall",
    //     description:
    //         "Bring your best dish & participate in the Brothers vs Sisters competition to see who take home the trophy!!",
    //     venue: "ICSP - Community Hall",
    // }
]

export default upcomingEvents;